import Matomo from 'matomo-ts'

const SITE_ID = 2
const MATOMO_URL = '//tracker.lithe.net/matomo.php'

const tracker = Matomo.default()
if (process.env.NODE_ENV !== 'development') {
	tracker.init(MATOMO_URL, SITE_ID)
	tracker.trackPageView()
} else {
	global._paq = { push: () => {} }
}

export default tracker
